import React from 'react';
import PropTypes from 'prop-types';

// Components
import CompareTableItem from '@/braun/components/molecules/CompareTableItem';

const CompareTableRow = ({ isFirstProduct, features, titles }) => {
  const featureValues = features.map((feature, i) => (
    <CompareTableItem
      key={`compare-table-item-${titles[i]}`}
      isFirstProduct={isFirstProduct}
      feature={feature}
      title={titles[i]}
    />
  ));

  return (
    <tr
      className={`bra-comparsionTable__row ${
        isFirstProduct ? '-mobileTitle' : ''
      }`}
    >
      {featureValues}
    </tr>
  );
};

CompareTableRow.propTypes = {
  isFirstProduct: PropTypes.bool.isRequired,
  features: PropTypes.arrayOf(PropTypes.string).isRequired,
  titles: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default CompareTableRow;
